<template>
    <tr class="dashboard__list_enrolments_table_item_collapse_table_item">
        <td class="dashboard__list_enrolments_table_item_collapse_table_item_title">{{ moduleTitle }}</td>
        <td class="dashboard__list_enrolments_table_item_collapse_table_item_type">{{ moduleType }}</td>
        <td class="dashboard__list_enrolments_table_item_collapse_table_item_enrolmentdate">{{ moduleStartDate }}</td>
        <td class="dashboard__list_enrolments_table_item_collapse_table_item_completiondate">
            {{ moduleCompletionDate }}
            <component-text :size="'tiny'">
                Time: {{ moduleCompletionTime }}
            </component-text>
        </td>
        <td class="dashboard__list_enrolments_table_item_collapse_table_item_status">
                <div class="columns is-vcentered">
                    <div class="column is-narrow">
                        <component-status :status="moduleCompletionState"/>
                    </div>
                </div>
        </td>
        <td class="dashboard__list_enrolments_table_item_collapse_table_item_score">
            <component-text
                :heading="true"
            >{{ moduleScore }}%
            </component-text>
        </td>
        <td class="dashboard__list_enrolments_table_item_collapse_table_item_actions">
            <template v-if="statusEditable">
                <div class="columns is-variable">
                    <div class="column"></div>
                    <div class="column is-narrow">
                        <component-button
                            :disabled="!statusValue"
                            :name="`lms-superadmin-users-profile-edit-learning-history-table-item-save`"
                            :animate-loading="true"
                            :animate-loading-event-name="'save-enrolment-status'"
                            @click="performSaveEnrolmentStatus"
                        >Save
                        </component-button>
                    </div>
                    <div class="column is-narrow">
                        <component-button
                            :name="`lms-superadmin-users-profile-edit-learning-history-table-item-abort`"
                            :theme="'default'"
                            :icon="true"
                            :icon-name="'x'"
                            @click="disableStatusEditable"
                        ></component-button>
                    </div>
                </div>
            </template>
        </td>
    </tr>
</template>

<script>

import { sortByKey, toLocaleTime, toLocaleDateTime, fromUTCDateTimeToLocalISOCustom } from '@/functions'
import ComponentButton from '@/components/default/shared/ComponentButton'
import ComponentText from '@/components/default/shared/ComponentText'
import ComponentStatus from '@/components/default/shared/ComponentStatus'

export default {
  name: 'dashboard-list-enrolments-table-item-collapse-table-item',
  components: { ComponentStatus, ComponentText, ComponentButton },
  computed: {
    occurrenceItemDate () {
      const dateStart = toLocaleDateTime(fromUTCDateTimeToLocalISOCustom(this.item.datetimeStart || this.item.startDate))
      const dateEnd = toLocaleDateTime(fromUTCDateTimeToLocalISOCustom(this.item.datetimeEnd || this.item.endDate))
      return dateStart !== dateEnd ? `${dateStart} - ${dateEnd}` : dateStart
    },
    occurrenceItemTime () {
      const timeStart = toLocaleTime(fromUTCDateTimeToLocalISOCustom(this.item.datetimeStart || this.item.startDate))
      const timeEnd = toLocaleTime(fromUTCDateTimeToLocalISOCustom(this.item.datetimeEnd || this.item.endDate))
      return timeStart + ' - ' + timeEnd
    },
    occurrenceItemTrainers () {
      return sortByKey(this.item.trainers, 'name')
    },
    occurrenceItemLocation () {
      const location = this.item.location
      const venue = this.item.venue ? this.item.venue.name : null
      const room = this.item.room ? this.item.room.name : null
      return location || (venue && room ? `${venue} - ${room}` : '')
    },
    occurrenceItemAddress () {
      return this.item.location || this.item.venue.address
    },
    occurrenceItemAddressFormatted () {
      return this.item.location ? this.item.location : (this.item.venue.address.formatted_address + (this.item.room.location ? `(${this.item.room.location})` : ''))
    }
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  methods: {
    openNotifyMap () {
      this.$refs.notifymap.openNotify()
    }
  }
}
</script>
